import { Alert, AlertDescription } from '../ui/alert'
import { Mail } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

export default function VerifyEmailAlert() {
  const { user } = useAuth()
  
  // Only show if user exists and email is not verified
  if (!user || user.emailVerifiedAt) {
    return null
  }

  return (
    <Alert className="border-amber-200 bg-amber-50">
      <Mail className="h-4 w-4" />
      <AlertDescription>
        Your email address is not verified. Please check your inbox for a verification link.
        <span className="text-xs text-muted-foreground ml-2">(Email verification is currently bypassed for development)</span>
      </AlertDescription>
    </Alert>
  )
}